import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import { useContext } from "react";

const Amount = () => {
  const location = useLocation();
  const info = location.state;
  console.log(info);
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);

  const [amount, setAmount] = React.useState(0);
  const [error, setError] = useState("");

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setError(""); // Clear previous error

    // Don't allow negative numbers
    if (value < 0) {
      setError("Amount cannot be negative");
      return;
    }

    // Validate decimal places (max 2)
    if (value.includes(".") && value.split(".")[1].length > 2) {
      setError("Maximum 2 decimal places allowed");
      return;
    }

    setAmount(value);
  };

  const btnClicked = () => {
    try {
      if (amount >= 50 && amount <= info.UserId.PaymentBalance) {
        navigate("/user-dashboard/withdraw/review", {
          state: { amount: amount, email: info?.AttachedPaypal?.Email },
        });
      } else {
        showAlert("Invalid amount", "danger");
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <div className="flex justify-center font-pop items-center py-20">
      <div className="mx-6 bg-white max-w-md w-full p-4 md:p-8 rounded-lg shadow-md">
        <h2 className="text-lg md:text-2xl font-pop font-semibold mb-4">
          Withdraw money
        </h2>
        <p className="text-gray-600  text-sm md:text-base mb-6 max-w-sm">
          Paycott balance ({info?.UserId?.PaymentBalance} USD) PayPal (
          {info?.AttachedPaypal?.Email.substring(0, 4)} ****)
        </p>
        {/* <form> */}

        <div className="flex flex-col font-pop gap-4">
          <div className="flex flex-col gap-1">
            <input
              type="number"
              min="0"
              step="0.01"
              className={`text-2xl text-black px-0 border-none outline-none 
                                active:border-none focus:outline-0 focus:outline-none
                                ${error ? "text-red-500" : ""}`}
              placeholder="0.00 USD"
              onChange={handleAmountChange}
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
            <p className="text-sm text-gray-400">min 50.00USD</p>
          </div>
          <button
            className="my-4 w-full bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-lg md:text-xl py-1 md:py-3 px-4 border border-black-500 hover:border-green-500 rounded-full  text-white animate__animated animate__backInUp "
            onClick={btnClicked}
          >
            {/*<Link to={`/user-dashboard/withdraw/review?amount=${Number(amount).toFixed(2)}`}>*/}
            {/*    Next*/}
            {/*</Link>*/}
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Amount;
